import React from 'react';

const topBar = () => {
  return (
    <div className='top-bar pt-1 pb-1 text-light'>
      <div className='container'>
        <div className='d-flex justify-content-between'>
          <div className='d-flex pt-2 pb-2'>
            <div className='d-flex align-item-center'>
              <i className='fas fa-phone-alt mr-2' />
              <small>(+61) 0478 860 866</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default topBar;
